import { render, staticRenderFns } from "./SidebarAddNewProduct.vue?vue&type=template&id=2eae9770&"
import script from "./SidebarAddNewProduct.vue?vue&type=script&lang=js&"
export * from "./SidebarAddNewProduct.vue?vue&type=script&lang=js&"
import style0 from "./SidebarAddNewProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports